module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Light.eefbdd88.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-Walsheim-Light.woff
// module id = 651
// module chunks = 0